/* eslint-disable import/no-named-as-default-member */
import React, { Component } from 'react'
import { connect } from 'react-redux'
import { Segment, Header } from 'semantic-ui-react'
import RestaurantForm from '../../components/restaurants/forms/storeForm'
import RestaurantActions from '../../reducers/restaurantReducer'

class EditRestaurants extends Component {
  componentDidMount() {
    const { fetchRestaurant, match } = this.props
    const { id } = match.params

    fetchRestaurant(id)
  }

  render() {
    const { match, restaurants } = this.props
    const restaurant = restaurants[match.params.id]

    return (
      <div>
        <Segment color="black" style={{ marginBottom: 20 }}>
          <Header size="large">Edit Restaurant</Header>
          <RestaurantForm
            editRestaurant={{ branches: {}, ...restaurant }}
            firebaseKey={match.params.id}
            action="Edit"
          />
        </Segment>
      </div>
    )
  }
}

const mapStateToProps = state => ({
  restaurants: state.restaurants.data,
})

const mapDispatchToProps = dispatch => ({
  fetchRestaurant: id => dispatch(RestaurantActions.fetchRestaurantRequest(id)),
})

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(EditRestaurants)



// WEBPACK FOOTER //
// ./src/containers/restaurants/edit.js